// extracted by mini-css-extract-plugin
module.exports = {"banner":"HomePage_banner__11566","darkbanner":"HomePage_darkbanner__TiTo5"};